import { useId } from 'react';
import './bckt-upload-spinner.css';

/** Omit progress for an indeterminate operation. Values are percentages. */
export function BcktUploadSpinner({ progress, size = 24, label = 'Uploading' }: { progress?: number; size?: number; label?: string }) {
  const clip = `bckt-upload-${useId().replace(/:/g, '')}`;
  const value = progress !== undefined && Number.isFinite(progress) ? Math.max(0, Math.min(100, progress)) : undefined;
  return (
    <svg className="bckt-upload-spinner" width={size} height={size} viewBox="0 0 500 500" role="progressbar" aria-label={label} aria-valuemin={0} aria-valuemax={100} aria-valuenow={value} aria-valuetext={value === undefined ? 'Uploading' : value >= 100 ? 'Finalizing upload' : `${Math.round(value)}% uploaded`}>
      <defs><clipPath id={clip}><circle cx="250" cy="250" r="250" /></clipPath></defs>
      <g clipPath={`url(#${clip})`}><g transform="rotate(-30 250 250)">
        {[12.5, 187.5, 362.5].map(x => <rect key={x} x={x} y="-93.75" width="125" height="687.5" rx="50" />)}
      </g></g>
    </svg>
  );
}
